module.exports = __webpack_public_path__ + "img/幸运抽签@2x.2bc88070.png";